export function sanitizeFaqHtml(html: string): string {
  try {
    const parser = new DOMParser()
    const doc = parser.parseFromString(String(html || ''), 'text/html')
    const allowed = new Set(['A','P','STRONG','EM','UL','OL','LI','BR','B','I'])
    const walk = (node: Node) => {
      const toRemove: Node[] = []
      node.childNodes.forEach((child) => {
        if (child.nodeType === Node.ELEMENT_NODE) {
          const el = child as HTMLElement
          if (!allowed.has(el.tagName)) {
            // Replace disallowed element by its text content (unwrap)
            const frag = doc.createDocumentFragment()
            while (el.firstChild) frag.appendChild(el.firstChild)
            el.replaceWith(frag)
          } else {
            // Clean attributes
            for (const attr of Array.from(el.attributes)) {
              if (el.tagName === 'A' && (attr.name === 'href' || attr.name === 'target' || attr.name === 'rel')) continue
              el.removeAttribute(attr.name)
            }
            if (el.tagName === 'A') {
              const href = (el.getAttribute('href') || '').trim()
              const safe = /^https?:\/\//i.test(href)
              if (!safe) {
                el.removeAttribute('href')
              } else {
                el.setAttribute('target','_blank')
                el.setAttribute('rel','noopener noreferrer nofollow')
              }
            }
          }
        }
        walk(child)
      })
      toRemove.forEach(n => n.parentNode?.removeChild(n))
    }
    walk(doc.body)
    const out = doc.body.innerHTML || ''
    const hasTags = /<\s*(p|br|ul|ol|li|a|strong|em|b|i)\b/i.test(out)
    if (!hasTags) {
      // Fallback: se veio texto puro com quebras de linha, preserva como <br>
      const txt = (doc.body.textContent || '').replace(/\r\n/g, '\n')
      const esc = txt
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/\"/g, '&quot;')
        .replace(/'/g, '&#39;')
      return esc.replace(/\n/g, '<br>')
    }
    return out
  } catch {
    return String(html || '')
  }
}
